export function defaultAvatar() {
    return '/images/profile.jpg';
}